<script setup>
   import config from '@/config'

   const localMedia = config.localMedia

   const props = defineProps({
      size: {
         type: String,
         default: '100'
      }
   })
</script>

<template>
   <img :src="`${localMedia}/logos/codeginnel-logo.svg`" alt="CodeGinnel Logo" :style="`width: 100%; max-width: ${size}px;`" />
</template>